var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-field-list-view", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "modal-title" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-type" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/new-form-ui/field-icon/" +
                (_vm.dataField.field === "icon" ? "image" : "field") +
                ".svg")
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-type" }, [
            _vm._v(
              _vm._s(
                _vm.dataField.field
                  .replace("text", "field")
                  .split("_")
                  .join(" ")
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrap-content" },
        [
          _vm.dataField.field !== "icon"
            ? _c(
                "div",
                { staticClass: "section-field input-field" },
                [
                  _c(
                    "b-form",
                    { class: { "error-input": _vm.$v.dataSetup.type.$error } },
                    [
                      _c("label", [_vm._v(" Format ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          custom: true,
                          options: _vm.formatOptions,
                          placeholder: "Select format"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "node-custom",
                            fn: function(node) {
                              return [
                                _c("img", {
                                  staticStyle: {
                                    width: "14px",
                                    height: "auto",
                                    "margin-right": "5px"
                                  },
                                  attrs: {
                                    src: require("@/assets/icon/column-type/" +
                                      _vm.setIconType(node.node.id) +
                                      ".svg")
                                  }
                                }),
                                _vm._v(
                                  " " + _vm._s(node.node.label) + "\n          "
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.dataSetup.type,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "type", $$v)
                          },
                          expression: "dataSetup.type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.dataSetup.type === "datetime" ||
                  _vm.dataSetup.type === "time" ||
                  _vm.dataSetup.type === "dd-mmm-yyyy" ||
                  _vm.dataSetup.type === "mmmm dd, yyyy" ||
                  _vm.dataSetup.type === "MMMM dd, yyyy"
                    ? _c(
                        "b-form",
                        [
                          _c("label", [_vm._v(" Timezone ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.listTimezone,
                              placeholder: "Select Timezone",
                              label: "text",
                              "value-format": "object"
                            },
                            model: {
                              value: _vm.dataSetup.timezone,
                              callback: function($$v) {
                                _vm.$set(_vm.dataSetup, "timezone", $$v)
                              },
                              expression: "dataSetup.timezone"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataField.field !== "icon"
            ? _c(
                "div",
                { staticClass: "section-field input-field" },
                [
                  _c("p", { staticClass: "title-section" }, [
                    _vm._v("Parse Value To")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: { "error-input": _vm.$v.dataSetup.variable.$error }
                    },
                    [
                      _c("label", [_vm._v(" Column ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variableOptionsFiltered,
                          placeholder: "Select Column",
                          disabled: !_vm.dataSetup.type,
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.variable,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup, "variable", $$v)
                          },
                          expression: "dataSetup.variable"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataSetup.type === "text" && _vm.parseValueTimer
            ? _c(
                "b-form",
                [
                  _c("label", [_vm._v(" Timezone ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      options: _vm.listTimezone,
                      placeholder: "Select Timezone",
                      label: "text",
                      "value-format": "object"
                    },
                    model: {
                      value: _vm.dataSetup.timezone,
                      callback: function($$v) {
                        _vm.$set(_vm.dataSetup, "timezone", $$v)
                      },
                      expression: "dataSetup.timezone"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataField.field === "icon"
            ? _c("div", { staticClass: "configuration-section" }, [
                _c("h4", { staticClass: "configuration-section-title" }, [
                  _vm._v("Icon Source")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "configuration-section-desc" }, [
                  _vm._v(
                    "\n        Select the type of source file used to be used as an icon on the list item\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  _vm._l(_vm.iconOptions, function(icon) {
                    return _c(
                      "div",
                      {
                        key: icon.id,
                        staticClass: "div-list-icon-source",
                        class: { active: icon.id === _vm.iconSource },
                        on: {
                          click: function($event) {
                            _vm.iconSource = icon.id
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(icon.name) + "\n        "
                        )
                      ]
                    )
                  })
                ),
                _vm._v(" "),
                _vm.iconSource === "upload"
                  ? _c(
                      "div",
                      {
                        staticClass: "icon-configuration",
                        class: {
                          "error-input": _vm.$v.dataIconSourceUpload.$error
                        }
                      },
                      [
                        _c("div", { staticClass: "wrap-icon" }, [
                          _c("div", { staticClass: "div-icon" }, [
                            _c("input", {
                              ref: "fileInput",
                              attrs: { type: "file" },
                              on: { change: _vm.handleUpload }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.dataIconSourceUpload &&
                                    _vm.dataIconSourceUpload.includes("http"),
                                  expression:
                                    "dataIconSourceUpload && dataIconSourceUpload.includes('http')"
                                }
                              ],
                              attrs: { src: _vm.dataIconSourceUpload }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.dataIconSourceUpload,
                                  expression: "!dataIconSourceUpload"
                                }
                              ],
                              staticStyle: { width: "15px", height: "15px" },
                              attrs: {
                                src: require("@/assets/new-form-ui/default-icon.svg")
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2" }, [
                            _c("p", { staticClass: "icon-name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dataIconSourceUpload || "No File Uploaded"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.dataIconSourceUpload
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex align-items-center" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass: "icon-change mr-3",
                                        on: { click: _vm.clearIcon }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Clear\n              "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "icon-change",
                                        on: { click: _vm.changeIcon }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Change\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticClass: "icon-change",
                                    on: { click: _vm.changeIcon }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Upload\n            "
                                    )
                                  ]
                                )
                          ])
                        ])
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "icon-configuration" },
                      [
                        _c("p", { staticClass: "title-section" }, [
                          _vm._v("Parse Value To")
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          {
                            class: {
                              "error-input": _vm.$v.dataIconSourceColumn.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.variableOptions,
                                placeholder: "Select Column",
                                label: "label"
                              },
                              model: {
                                value: _vm.dataIconSourceColumn,
                                callback: function($$v) {
                                  _vm.dataIconSourceColumn = $$v
                                },
                                expression: "dataIconSourceColumn"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end mt-2" }, [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "button-blue", on: { click: _vm.submitForm } },
          [_vm._v("\n      Apply\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n      Properties\n      "),
      _c("div", { staticClass: "title-badge" }, [_vm._v("Field on List View")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d47bc306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d47bc306","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalFieldListView.vue
// module id = null
// module chunks = 